module.exports = __webpack_public_path__ + "img/1.09a824df.png";